import { BitfStrapiModel } from '@common/libs/bitforce/core/models';
import { Convention } from './convention.model';
import { IRole } from '@common/interfaces/role.interface';
import { Group } from './group.model';

export class User extends BitfStrapiModel {
  name: string;
  surname: string;
  email: string;
  conventions: Convention[];
  groups: Group[];
  role: IRole;

  constructor(data: Partial<User>) {
    super({ data });

    if (data.conventions) {
      this.conventions = data.conventions.map(convention => new Convention(convention));
    }

    if (data.groups) {
      this.groups = data.groups.map(group => new Group(group));
    }
  }

  get serialised() {
    return {
      id: this.id,
      documentId: this.documentId,
      name: this.name,
      surname: this.surname,
      email: this.email,
      conventions: this.conventions.map(convention => convention.serialised),
    };
  }

  get isAdmin() {
    return this.role?.type === 'super_admin';
  }
}
